import {
  UPDATEGATEWAYTRANSACTIONSTATUSADMIN_SUCCESS,
  UPDATEGATEWAYTRANSACTIONSTATUSADMIN_FAILED,
  RESET_UPDATEGATEWAYTRANSACTIONSTATUSADMIN,
  LOADING_UPDATEGATEWAYTRANSACTIONSTATUSADMIN,
  NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSADMIN,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateGatewayTransactionAdmin = () => {
  return { type: RESET_UPDATEGATEWAYTRANSACTIONSTATUSADMIN };
};

const AdminUpdateGatewayTransactions =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEGATEWAYTRANSACTIONSTATUSADMIN });
    await partnerServices
      .post("updateGatewayTransactionStatus", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(UpdateGatewayTransAdminsuccess(res.data));
            break;
          case "success":
            dispatch(UpdateGatewayTransAdminsuccess(res.data));
            break;
          default:
            dispatch(UpdateGatewayTransAdminFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSADMIN,
          payload: err,
        });
      });
  };
function UpdateGatewayTransAdminsuccess(data) {
  return {
    type: UPDATEGATEWAYTRANSACTIONSTATUSADMIN_SUCCESS,
    payload: data,
  };
}
function UpdateGatewayTransAdminFailed(data) {
  return {
    type: UPDATEGATEWAYTRANSACTIONSTATUSADMIN_FAILED,
    payload: data,
  };
}

export { resetUpdateGatewayTransactionAdmin, AdminUpdateGatewayTransactions };
